import travelClient from './travelClient';
import { travelEndpoints } from './endpoints';

function parseTravelJson(raw) {
  if (typeof raw !== 'string' || !raw) return raw;
  const text = raw.replace(
    /("(?:journeyId|situationId|createdByMemberId|assignedToMemberId|resolvedByMemberId|cancelledByMemberId|linkedActivityId|memberId|ownerMemberId|creatorMemberId)"\s*:\s*)(\d{15,})/g,
    '$1"$2"',
  );
  return JSON.parse(text);
}

const snowflakeJson = { transformResponse: [parseTravelJson] };

function listConfig(filters = {}) {
  const params = {};
  if (filters.status) params.status = filters.status;
  if (filters.severity) params.severity = filters.severity;
  if (filters.situationType) params.situationType = filters.situationType;
  return { ...snowflakeJson, params };
}

export const journeySituationApi = {
  list: (journeyId, filters) => travelClient.get(
    travelEndpoints.journeySituations(journeyId),
    listConfig(filters),
  ),
  get: (journeyId, situationId) => travelClient.get(
    travelEndpoints.journeySituation(journeyId, situationId),
    snowflakeJson,
  ),
  create: (journeyId, body) => travelClient.post(
    travelEndpoints.journeySituations(journeyId),
    body,
    snowflakeJson,
  ),
  update: (journeyId, situationId, body) => travelClient.patch(
    travelEndpoints.journeySituation(journeyId, situationId),
    body,
    snowflakeJson,
  ),
  assign: (journeyId, situationId, body) => travelClient.post(
    travelEndpoints.journeySituationAssign(journeyId, situationId),
    body,
    snowflakeJson,
  ),
  resolve: (journeyId, situationId, body) => travelClient.post(
    travelEndpoints.journeySituationResolve(journeyId, situationId),
    body,
    snowflakeJson,
  ),
  cancel: (journeyId, situationId, body) => travelClient.post(
    travelEndpoints.journeySituationCancel(journeyId, situationId),
    body,
    snowflakeJson,
  ),
};
